var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "editarCenterSet",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c("v-card", { attrs: { id: "cardDivTV" } }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "cardnew", attrs: { align: "center" } },
            [
              _c("br"),
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validForm,
                            callback: function($$v) {
                              _vm.validForm = $$v
                            },
                            expression: "validForm"
                          }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "div",
                                { attrs: { align: "left" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between"
                                      },
                                      attrs: { md12: "" }
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass: "h2_title",
                                          staticStyle: {
                                            "margin-top": "12px !important"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.esEdicion
                                                  ? "Editar Center Set"
                                                  : "Ver Detalle Center Set Howen"
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      ),
                                      _vm.esEdicion
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "btn-grabar",
                                              attrs: { depressed: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.confirmCallbackConfirm(
                                                    true
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Guardar Cambios")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("CMS")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [_c("v-divider")],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.protocol.label,
                                          items: _vm.formFields.protocol.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedProtocol,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.protocol.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.protocol,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.protocol.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm6: "",
                                        md6: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.server1.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.server1.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.server1,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.server1.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm2: "",
                                        md2: "",
                                        lg2: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.serverPort1.label,
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.serverPort1.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.serverPort1,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.serverPort1.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.protocol.label,
                                          items: _vm.formFields.protocol.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedProtocol,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.protocol.value1,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.protocol,
                                              "value1",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.protocol.value1"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm6: "",
                                        md6: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.server2.label,
                                          disabled: !_vm.esEdicion
                                        },
                                        model: {
                                          value: _vm.formFields.server2.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.server2,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.server2.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm2: "",
                                        md2: "",
                                        lg2: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.serverPort2.label,
                                          disabled: !_vm.esEdicion
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.serverPort2.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.serverPort2,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.serverPort2.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.protocol.label,
                                          items: _vm.formFields.protocol.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedProtocol,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.protocol.value2,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.protocol,
                                              "value2",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.protocol.value2"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm6: "",
                                        md6: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.server3.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.server3.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.server3,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.server3.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm2: "",
                                        md2: "",
                                        lg2: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.serverPort3.label,
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.serverPort3.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.serverPort3,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.serverPort3.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.protocol.label,
                                          items: _vm.formFields.protocol.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedProtocol,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.protocol.value3,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.protocol,
                                              "value3",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.protocol.value3"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm6: "",
                                        md6: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.server4.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.server4.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.server4,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.server4.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm2: "",
                                        md2: "",
                                        lg2: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.serverPort4.label,
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.serverPort4.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.serverPort4,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.serverPort4.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.crud.editarCamara.titulo"),
          mensaje: _vm.$t("mensajes.crud.editarCamara.mensaje"),
          textoBtnSi: _vm.$t("mensajes.crud.editarCamara.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editarCamara.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.grabarEdicion($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }